goog.provide("shadow.js.shim.module$$launchdarkly$observability$default");
shadow.js.shim.module$$launchdarkly$observability$default = shadow.js.shim.module$$launchdarkly$observability.default;
